import { render, staticRenderFns } from "./ButtonRewardsClub.vue?vue&type=template&id=b8e5d538&"
import script from "./ButtonRewardsClub.vue?vue&type=script&lang=ts&"
export * from "./ButtonRewardsClub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports